module.exports = __webpack_public_path__ + "img/54.96501acb.png";